import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const reveniumPlugin = createPlugin({
  id: 'revenium-frontend',
  routes: {
    root: rootRouteRef,
  },
});

export const ProductCarouselPage = reveniumPlugin.provide(
  createRoutableExtension({
    name: 'ProductCarouselPage',
    component: () =>
      import('./components/ProductCarouselComponent').then(
        m => m.ProductCarouselComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ProductDetailsPage = reveniumPlugin.provide(
  createRoutableExtension({
    name: 'ProductDetailsPage',
    component: () =>
      import('./components/ProductDetailsComponent').then(
        m => m.ProductDetailsComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
